// @material-ui/core
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Switch,
  TextField,
  Typography
} from "@material-ui/core";
import moment from "moment";
import React, { Component } from "react";
import { withRouter } from "react-router";
import MainButton from "../../library/button/MainButton";
import Caba from "../../services/Caba";

class LicenseEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      license: {
        customer: "",
        app: "",
        start: "",
        end: "",
        isTrial: "",
        numLicenses: 0,
        autoprovisioning: true
      },
      customer: {
        name: ""
      }
    };

    props.toggleLoading(true);

    // make a call
    Caba.get("/api/v1/licenses/" + props.match.params.id)
      .then(response => {
        this.props.toggleLoading(false);
        this.setState({
          license: {
            ...response.data,
            start: moment(response.data.start).format("YYYY-MM-DDTHH:ss"),
            end: moment(response.data.end).format("YYYY-MM-DDTHH:ss")
          }
        });
        if (!response.data.app) {
          return new Promise((resolve, reject) => {
            reject();
          });
        }
        return Caba.get("/api/v1/customers/" + response.data.customer);
      })
      .then(response => {
        this.setState({
          customer: response.data
        });
      });
  }

  handleTrigger = name => (event, checked) => {
    this.setState({
      license: {
        ...this.state.license,
        [name]: checked
      }
    });
  };

  handleChange = name => event => {
    if (name === "numLicenses") {
      this.setState({
        license: {
          ...this.state.license,
          [name]: parseInt(event.target.value, 10)
        }
      });
    } else {
      this.setState({
        license: { ...this.state.license, [name]: event.target.value }
      });
    }
  };

  handleClick = () => {
    Caba.put("/api/v1/licenses/" + this.props.match.params.id, {
      ...this.state.license,
      start: moment(this.state.license.start).toISOString(),
      end: moment(this.state.license.end).toISOString()
    }).then(response => {
      if (response.status === 200) {
        this.props.notify("success", "200", "Saved");
        this.props.history.push(
          "/licenses/" + this.props.match.params.id + "/view"
        );
      }
    });
  };

  render() {
    const { license, customer } = this.state;

    return (
      <Card>
        <CardHeader
          title={
            (license.appName ? license.appName + ": " : "") +
            this.state.customer.name
          }
        />
        <CardContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography type="subheading">
                <small>license</small>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>ID</small>
                  </Typography>
                  <TextField
                    id="id"
                    value={license.id ? license.id : ""}
                    onChange={this.handleChange("id")}
                    margin="dense"
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>Customer</small>
                  </Typography>
                  <TextField
                    id="customer"
                    value={
                      customer.name
                        ? customer.name
                        : license.customer ? license.customer : ""
                    }
                    onChange={this.handleChange("customer")}
                    margin="dense"
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>App</small>
                  </Typography>
                  <TextField
                    id="appName"
                    value={license.appName ? license.appName : ""}
                    onChange={this.handleChange("appName")}
                    margin="dense"
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>Start Date</small>
                  </Typography>
                  <TextField
                    id="start"
                    value={license.start ? license.start : ""}
                    onChange={this.handleChange("start")}
                    type="datetime-local"
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>End Date</small>
                  </Typography>
                  <TextField
                    id="end"
                    value={license.end ? license.end : ""}
                    onChange={this.handleChange("end")}
                    type="datetime-local"
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>Trial</small>
                  </Typography>
                  <Switch
                    id="isTrial"
                    checked={license.isTrial ? true : false}
                    onChange={this.handleTrigger("isTrial")}
                    aria-label="isTrial"
                    margin="dense"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>License Count</small>
                  </Typography>
                  <TextField
                    id="numLicenses"
                    type="number"
                    value={license.numLicenses ? license.numLicenses : ""}
                    onChange={this.handleChange("numLicenses")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography type="subheading">
                  <small>Auto Provisioning</small>
                </Typography>
                <Switch
                  id="autoprovisioning"
                  checked={license.autoprovisioning ? true : false}
                  onChange={this.handleTrigger("autoprovisioning")}
                  aria-label="autoprovisioning"
                  margin="dense"
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <MainButton
                colored="blue"
                raised
                fullWidth
                onClick={this.handleClick}>
                Save
              </MainButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withRouter(LicenseEdit);



// WEBPACK FOOTER //
// ./src/pages/licenses/LicenseEdit.js